/**
 * Explore IA v2 secondary navigation（FE-IA-V2-02）。
 * Canonical：推薦 / 追蹤中 / 地圖。
 * Public Journeys 使用獨立主要入口；舊 discovery deep link 保留轉址。揪團維持既有入口。
 */

export const EXPLORE_IA_SECONDARY = Object.freeze([
  {
    id: 'for-you',
    tab: 'for-you',
    labelKey: 'travel.discover.tabs.forYou',
    testId: 'discover-tab-for-you',
  },
  {
    id: 'following',
    tab: 'following',
    labelKey: 'travel.discover.posts.following',
    testId: 'discover-tab-following',
  },
  {
    id: 'map',
    tab: 'map',
    labelKey: 'travel.discover.posts.map',
    testId: 'discover-tab-map',
  },
]);

/**
 * OLD_ROUTE → IA_V2_OWNER → CANONICAL_UI → COMPATIBILITY_ACTION
 */
export const EXPLORE_IA_ROUTE_COMPATIBILITY = Object.freeze([
  {
    oldRoute: '/explore',
    owner: 'explore',
    destination: '/explore?tab=for-you',
    action: 'KEEP_DEFAULT_RECOMMENDED',
  },
  {
    oldRoute: '/explore?tab=for-you',
    owner: 'explore.recommended',
    destination: '/explore?tab=for-you',
    action: 'KEEP',
  },
  {
    oldRoute: '/explore?tab=social',
    owner: 'explore.posts',
    destination: '/explore?tab=social',
    action: 'KEEP_DEEP_LINK_NOT_SECONDARY_TAB',
  },
  {
    oldRoute: '/explore?tab=social&view=map',
    owner: 'explore.map',
    destination: '/explore?tab=social&view=map',
    action: 'KEEP_SOCIAL_MAP_DEEP_LINK',
  },
  {
    oldRoute: '/explore?tab=map',
    owner: 'explore.map',
    destination: '/explore?tab=map',
    action: 'CANONICAL_MAP',
  },
  {
    oldRoute: '/explore?tab=journeys',
    owner: 'public-journeys',
    destination: '/discover/journeys',
    action: 'REDIRECT_WITH_FILTERS',
  },
  {
    oldRoute: '/social/following',
    owner: 'explore.following',
    destination: '/social/following',
    action: 'KEEP_ROUTE_PLUS_EXPLORE_TAB',
  },
  {
    oldRoute: '/explore?tab=following',
    owner: 'explore.following',
    destination: '/explore?tab=following',
    action: 'CANONICAL_FOLLOWING_ENTRY',
  },
  {
    oldRoute: '/public/journeys/:publicationId',
    owner: 'public-journeys',
    destination: '/public/journeys/:publicationId',
    action: 'KEEP_READER',
  },
  {
    oldRoute: '/public/group-trips',
    owner: 'explore.groupTripDiscovery',
    destination: '/public/group-trips',
    action: 'KEEP_DISCOVERY',
  },
  {
    oldRoute: '/public/group-trips/:groupTripId',
    owner: 'explore.groupTripDiscovery',
    destination: '/public/group-trips/:groupTripId',
    action: 'KEEP_DETAIL',
  },
]);

export function isExploreIaSecondaryTab(tab) {
  return EXPLORE_IA_SECONDARY.some((item) => item.tab === tab);
}
